import { Button } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import { useState } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
type IProps = Pick<ISubscriptionPlan, 'subscriptionDescription'>;
const SubscriptionInoDescription: FC<IProps> = ({
  subscriptionDescription
}) => {
  const [open, setOpen] = useState(false);
  const items = subscriptionDescription?.split('\n') ?? [];
  const onToggle = () => setOpen(prev => !prev);
  return <div data-sentry-component="SubscriptionInoDescription" data-sentry-source-file="SubscriptionInoDescription.tsx">
      <div className={cs('transition-all duration-300 ease-in-out mx-6', open ? 'max-h-[50px]  mb-3   text-right ' : 'max-h-[50px]  mb-0 text-center ')}>
        <div className={cs(' text-sm font-semibold text-blackFive', !open && 'sm:block hidden')}>
          {open ? 'این اشتراک شامل:' : 'این اشتراک شامل چیه؟'}
        </div>
      </div>
      <div className={cs('transition-all duration-500 ease-in-out overflow-hidden', open ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0')}>
        {items.map(item => <li className="mb-3 flex flex-row items-center" key={item}>
            {item.includes('-') ? <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/exclude.webp`} className="ml-2 w-[16px] min-w-[16px] text-greenThree" alt="cancel" /> : <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/include.webp`} className="ml-2 w-[16px] min-w-[16px] text-greenThree" alt="accept" />}
            <span className="md:text-md text-sm text-blackFive">{item.replace('-', '')}</span>
          </li>)}
      </div>
      <div className={cs('transition-opacity duration-300 ease-in-out text-center sm:mt-2')}>
        <Button variant="transparent" onClick={onToggle} className="w-full text-sm text-blackFive sm:mt-0" data-sentry-element="Button" data-sentry-source-file="SubscriptionInoDescription.tsx">
          {open ? <IconChevronUp /> : <IconChevronDown />}
        </Button>
      </div>
    </div>;
};
export default SubscriptionInoDescription;